import { ENTITY_LABELS } from "./entityLabels";

// Counting needs both forms of the noun, and lower case, because the count sits inside a sentence:
// "10 ditë të veçanta u fshinë përgjithmonë". The standalone labels in entityLabels.ts are the
// definite singular ("Ditë e veçantë e orarit") and do not fit there.
const COUNTED_LABELS: Record<string, [string, string]> = {
  Trip: ["orar", "orare"],
  Schedule: ["ndalesë", "ndalesa"],
  Price: ["çmim", "çmime"],
  Line: ["linjë", "linja"],
  Station: ["stacion", "stacione"],
  City: ["qytet", "qytete"],
  Country: ["shtet", "shtete"],
  Operator: ["operator", "operatorë"],
  Bus: ["autobus", "autobusë"],
  BusTripMapping: ["autobus i orarit", "autobusë të orarit"],
  CustomTripWorkingDay: ["ditë e veçantë", "ditë të veçanta"],
  CustomTripReservabilityDate: ["datë rezervueshmërie", "data rezervueshmërie"],
  CustomTripWorkingDayPattern: ["model ditësh", "modele ditësh"],
  CustomTripWorkingDayPatternDate: ["datë e modelit", "data të modelit"],
  CustomReservationThreshold: ["kufi rezervimesh", "kufij rezervimesh"],
  TripsNotices: ["njoftim i orarit", "njoftime të orarit"],
  OperationalInterval: ["interval ditësh", "intervale ditësh"],
  Ticket: ["biletë", "bileta"],
  TicketUserInfo: ["pasagjer", "pasagjerë"],
  JourneyReservation: ["rezervim", "rezervime"],
  JourneyTicketMapping: ["biletë e rezervimit", "bileta të rezervimit"],
  Refund: ["rimbursim", "rimbursime"],
  RefundLine: ["rresht rimbursimi", "rreshta rimbursimi"],
  TicketInvoiceOnlyCancellation: [
    "anulim bilete në faturën e operatorit",
    "anulime biletash në faturën e operatorit"
  ],
  OperatorInvoice: ["faturë", "fatura"],
  OperatorInvoiceAdjustment: ["korrigjim fature", "korrigjime fature"],
  PaymentAttempt: ["përpjekje për pagesë", "përpjekje për pagesë"],
  PaymentDispute: ["kontestim pagese", "kontestime pagese"],
  PaymentProcessorRefund: ["rimbursim në kartelë", "rimbursime në kartelë"],
  OperatorCommisionFee: ["komision i operatorit", "komisione të operatorit"],
  OperatorEntityCommisionFee: ["komision i orarit", "komisione të orarit"],
  WalletCredit: ["lëvizje në Gjirafa Money", "lëvizje në Gjirafa Money"],
  CreditReservationMapping: ["bllokim i Gjirafa Money", "bllokime të Gjirafa Money"],
  WalletCreditConsumption: ["përdorim i Gjirafa Money", "përdorime të Gjirafa Money"],
  LocalizedProperty: ["përkthim", "përkthime"],
  Picture: ["foto", "foto"],
  EntityPictureMapping: ["foto", "foto"],
  BlogPictureMapping: ["foto e blogut", "foto të blogut"],
  Blog: ["blog", "blogje"],
  TravelBundle: ["paketë", "paketa"],
  TravelBundleDetail: ["periudhë e paketës", "periudha të paketës"],
  TravelBundleIncludeMapping: ["përfshirje në paketë", "përfshirje në paketë"],
  TravelBundleLocationMapping: ["qytet i paketës", "qytete të paketës"],
  TravelBundlePictureMapping: ["foto e paketës", "foto të paketës"],
  PromotionCode: ["kod promocional", "kode promocionale"],
  VoucherCode: ["kod voucher-i", "kode voucher-i"],
  UserAccount: ["përdorues", "përdorues"],
  UserRole: ["rol", "role"],
  PermissionRecord: ["leje", "leje"],
  GTFSLine: ["linjë GTFS", "linja GTFS"],
  GTFSTrip: ["orar GTFS", "orare GTFS"],
  GTFSStop: ["stacion GTFS", "stacione GTFS"],
  GTFSTripStop: ["ndalesë GTFS", "ndalesa GTFS"],
  GTFSShape: ["formë GTFS", "forma GTFS"],
  LinePage: ["faqe linje", "faqe linjash"],
  LinePageSection: ["seksion i faqes", "seksione të faqes"],
  CityPage: ["faqe qyteti", "faqe qytetesh"],
  EsimReservation: ["rezervim eSIM", "rezervime eSIM"],
  PermissionRecordUserRoleMapping: ["leje e rolit", "leje të rolit"],
  UserRoleMapping: ["rol i përdoruesit", "role të përdoruesit"],
  InvitedUserRoleMapping: ["rol i ftesës", "role të ftesës"],
  BlockedUser: ["përdorues i bllokuar", "përdorues të bllokuar"],
  GTFSBlockedEntity: ["bllokim GTFS", "bllokime GTFS"],
  Subscription: ["abonim", "abonime"]
};

// "1 ndalesë", "3 ndalesa". An entity with no counted form falls back to its label in lower case,
// which reads acceptably and is better than a missing noun.
export const countedEntity = (entityName: string, count: number): string => {
  const forms = COUNTED_LABELS[entityName];
  if (!forms) return `${count} ${(ENTITY_LABELS[entityName] ?? entityName).toLowerCase()}`;
  return `${count} ${count === 1 ? forms[0] : forms[1]}`;
};
